"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("./utils");
const v0 = (0, utils_1.buildTypes)({
    types: {
        SpaceHistoryRecord: {
            edited: "WhoAndWhen",
            old_data: "SpaceUpdate",
        },
        PostHistoryRecord: {
            edited: "WhoAndWhen",
            old_data: "PostUpdate",
        },
        ProfileHistoryRecord: {
            edited: "WhoAndWhen",
            old_data: "ProfileUpdate",
        },
    }
});
exports.default = [v0];
